import rollbar from './rollbar';

const mockRollbar = {
  critical: console.error,
  error: console.error,
  warning: console.warn,
  warn: console.warn, // Rollbar supports both warning and warn
  info: console.log,
  debug: console.log
};

function wrap(level) {
  return function() {
    const log = rollbar() || mockRollbar;
    log[level].apply(log, arguments);
  };
}

export default ['critical', 'error', 'warning', 'warn', 'info', 'debug'].reduce(
  (logs, level) => {
    logs[level] = wrap(level);
    return logs;
  },
  {}
);



// WEBPACK FOOTER //
// ./js/util/errorLog.js